import { render } from "./AddBeneficiaryModal.vue?vue&type=template&id=cc0ce794&scoped=true"
import script from "./AddBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./AddBeneficiaryModal.vue?vue&type=script&lang=js"

import "./AddBeneficiaryModal.vue?vue&type=style&index=0&id=cc0ce794&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0ce794"]])

export default __exports__